// useGetLogo.ts
import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useGetLogo = function () {
    return useApiCall(function (signal) { return api.logo.apiLogoGetLogoLinkGet({ signal: signal }); }, null, true, [], {
        error: 'Failed to fetch logo'
    });
};
